import React from 'react'
import Ashrena from 'assets/images/1.png'
import BBC from 'assets/images/new-homepage-assets/desktop/bbc_logo.svg'
import leftQuote from 'assets/images/quote-left.svg'

const Card2 = ({ background, invertedComma }) => {
  return (
    <div className="flex">
      <div>
        {invertedComma && (
          <img src={leftQuote} className="mt-10 ml-0 sm:ml-6" />
        )}
      </div>
      <div
        className={`right ${
          background ? background : 'bg-white'
        } pl-[26px]  p-6 sm:w-[393px] relative sm:mt-0 mt-8 sm:rounded-[20px]`}
        // style="box-shadow: 0px 6px 10px #00000029; border-radius: 22px;"
      >
        {invertedComma ? (
          ''
        ) : (
          <p className="font-medium text-[18px] font-sans">
            "Tomedes has been nothing but kind, <br /> knowledgeable and
            efficient!"{' '}
          </p>
        )}
        <p className="text-[#00173A] font-sans leading-relaxed pt-5">
          Tomedes has been nothing but kind, <br /> knowledgeable and
          efficient!...
          <br />
          Everything was seamless! I trusted <br />
          Tomedes so much they’re now <br /> working...with an even bigger{' '}
          <br /> project: interpreting a multi- <br />
          language Zoom meeting!
        </p>

        <div className="pt-12">
          <img src={Ashrena} alt="" />
          <p className="text-[18px] font-medium font-secondary pt-3">
            Ashrena Ali
            {invertedComma ? (
              <>
                <span className="text-[18px] font-medium font-secondary">
                  ,
                </span>
                <a
                  href="https://www.trustpilot.com/users/60945782a8fc63001b6f847b"
                  target="_blank"
                  className="ml-3 text-orange bold"
                >
                  Carolina Herrera
                </a>
              </>
            ) : (
              ''
            )}
          </p>
        </div>
      </div>
    </div>
  )
}

export default Card2
